import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { authClient } from '@/lib/auth-client';
import type { User } from '@/types';

interface AuthState {
  user: User | null;
  isLoading: boolean;
  isAuthenticated: boolean;
  error: Error | null;
  signOut: () => Promise<void>;
  refetch: () => void;
}

export function useAuth(): AuthState {
  const queryClient = useQueryClient();
  const { data: session, isPending, error, refetch } = authClient.useSession();

  const signOut = useCallback(async () => {
    await authClient.signOut();
    queryClient.invalidateQueries();
    window.location.href = '/login';
  }, [queryClient]);

  const user = session?.user as unknown as User | null;

  return {
    user,
    isLoading: isPending,
    isAuthenticated: !!user,
    error: error as Error | null,
    signOut,
    refetch,
  };
}

export function useUser(): User | null {
  const { user } = useAuth();
  return user;
}
